export const PREVIEW_CARD_HEIGHT = 380;
export const PREVIEW_CARD_MAX_WIDTH = 460;
export const PREVIEW_CARD_PROFILE_PIC_SIZE = '150px';
export const PREVIEW_CARD_PROFILE_PIC_SIZE_NUM = 150;
export const PREVIEW_NEXT_BUFFER = 106;
export const RESPONSIVE_LARGE_WIDTH = 540;
export const RESPONSIVE_SMALL_HEIGHT = 700;